import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Inject, input, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { adaptEchartsOptions, watchBodyDarkMode$ } from '@examdojo/core/widget';
import { EChartsOption } from 'echarts';
import { BarChart, GraphChart, LineChart, ScatterChart, TreeChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { NgxEchartsDirective, provideEchartsCore } from 'ngx-echarts';

echarts.use([
  BarChart,
  GraphChart,
  LineChart,
  ScatterChart,
  TreeChart,
  SVGRenderer,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
]);

@Component({
  selector: 'dojo-echarts-svg',
  standalone: true,
  imports: [NgxEchartsDirective],
  template: `<div
    echarts
    class="echarts-svg-chart"
    [options]="adaptedOptions()"
    [initOpts]="initOpts"
    [autoResize]="true"
  ></div>`,
  styles: `
    dojo-echarts-svg {
      display: flex;
      flex: 1 1 0;
      width: 100%;
      min-height: 0;

      .echarts-svg-chart {
        width: 100%;
        height: 100%;
      }

      svg {
        overflow: visible;
      }

      svg [clip-path] {
        clip-path: none;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [provideEchartsCore({ echarts })],
})
export class EchartsSvgComponent {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.isDark = toSignal(watchBodyDarkMode$(this.document), { initialValue: false });
  }

  private readonly isDark;

  readonly options = input<EChartsOption>({});
  readonly initOpts = { renderer: 'svg' } as const;

  readonly adaptedOptions = computed(() => adaptEchartsOptions(this.options(), this.document, this.isDark()));
}
